import * as React from 'react'
import { Select, FORM_ELEMENT_TYPES, FlowForm, FlowFormElement, Item } from 'prace-common-components'
import Grid from '@material-ui/core/Grid'
import { $SectionLabel, $FieldsGrid, $Summary, $ElementSpan } from './styles'
import { FinalReportOptionsProps } from './types'

export const FinalReportOptions: React.FC<FinalReportOptionsProps> = ({ step, config, onChange }) => {
  const { elements } = config
  const selectedId = elements[0]?.id ?? null

  /* Document-upload elements in this step are eligible, including those nested one level inside a
     group (groups don't nest deeper). A group can yield one file per instance, so the export emits
     one manifest row per (proposal, group instance) for group-nested uploads. */
  const uploadItems = React.useMemo<Item[]>(() => {
    const items: Item[] = []
    for (const form of (step.flow || []) as FlowForm[]) {
      for (const element of (form.flow || []) as FlowFormElement[]) {
        if (element.elementType === FORM_ELEMENT_TYPES.UPLOAD) {
          items.push({ value: element.id, label: `${form.title} > ${element.title}` })
        } else if (element.elementType === FORM_ELEMENT_TYPES.GROUP) {
          for (const child of (element.flow || []) as FlowFormElement[]) {
            if (child.elementType === FORM_ELEMENT_TYPES.UPLOAD) {
              items.push({ value: child.id, label: `${form.title} > ${element.title} > ${child.title}` })
            }
          }
        }
      }
    }
    return items
  }, [step])

  const handleChange = (_name: string, value: Nullable<StringNumber>) => {
    onChange({ ...config, elements: value ? [{ id: Number(value) }] : [] })
  }

  const selectedLabel = uploadItems.find((item) => item.value === selectedId)?.label

  return (
    <div>
      <$SectionLabel>Final Report Document</$SectionLabel>
      <$FieldsGrid container spacing={2}>
        <Grid item xs={12}>
          <Select
            name='finalReportElement'
            title='Document upload element'
            value={selectedId}
            items={uploadItems}
            placeholder={uploadItems.length ? 'Choose a document upload element' : 'No document upload elements in this step'}
            disabled={!uploadItems.length}
            onChange={handleChange}
          />
        </Grid>
      </$FieldsGrid>
      {selectedLabel && (
        <$Summary>
          The final report file is collected from <$ElementSpan>{selectedLabel}</$ElementSpan>.
        </$Summary>
      )}
    </div>
  )
}
